import { useSessionValue } from '@portal/appLayer/auth';
import { useIsEnabled } from '@portal/shared/hooks/useIsEnabled';
import { useLocale } from '@portal/shared/hooks/useLocale';
import { Feature } from '@portal/shared/utils/featureToggle';
import { LocaleEnum } from 'schema/locale';
import { useCloudfrontLocationQuery } from './useCloudfrontLocation';

export function useV53AccountIdentifier() {
  const session = useSessionValue();
  const isV53FeatureEnabled = useIsEnabled(Feature.V53);
  const { data } = useCloudfrontLocationQuery();
  const locale = useLocale();

  if (!session) {
    return false;
  }

  const customer = session?.customer;

  const customerHasTagsProperty =
    customer && Object.prototype.hasOwnProperty.call(customer, 'tags');
  const customerHasV52Tag = customer.tags?.includes('Legacy V52');
  const customerHasV52Locale =
    data?.isAPAC ||
    locale === LocaleEnum.apacUS ||
    locale === LocaleEnum.enAU ||
    locale === LocaleEnum.enNZ ||
    locale === LocaleEnum.enAud ||
    locale === LocaleEnum.enNzd;

  return (
    isV53FeatureEnabled && customerHasTagsProperty && !customerHasV52Tag && !customerHasV52Locale
  );
}
